import { useEffect, useRef, useState } from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ax/Button";
import { useI18n } from "@/i18n";

const ACTIONS = [
  { key: "park", status: "parked", labelKey: "sheet.park" },
  { key: "archive", status: "archived", labelKey: "sheet.archive" },
];

export const SheetMenu = ({ onStatus, onDelete }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <div
      ref={box}
      onBlur={(e) => !box.current?.contains(e.relatedTarget) && setOpen(false)}
      className="relative"
    >
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t("sheet.menu")}
        onClick={() => setOpen((v) => !v)}
        data-testid="sheet-menu-button"
        className="flex h-11 w-11 items-center justify-center rounded-[8px] text-ax-text-2 transition-colors duration-150 hover:bg-ax-surface"
      >
        <MoreHorizontal size={20} strokeWidth={1.5} aria-hidden="true" />
      </button>
      {open && (
        <div
          role="menu"
          data-testid="sheet-menu"
          className="absolute right-0 top-12 z-20 w-48 rounded-[12px] border border-ax-border bg-ax-surface p-2 shadow"
        >
          {ACTIONS.map((a) => (
            <Button
              key={a.key}
              role="menuitem"
              onClick={() => {
                setOpen(false);
                onStatus(a.status);
              }}
              data-testid={`sheet-menu-${a.key}`}
              className="w-full justify-start border-0 bg-transparent"
            >
              {t(a.labelKey)}
            </Button>
          ))}
          <Button
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onDelete();
            }}
            data-testid="sheet-menu-delete"
            className="w-full justify-start border-0 bg-transparent text-ax-error"
          >
            {t("sheet.deleteCta")}
          </Button>
        </div>
      )}
    </div>
  );
};
